import React from 'react';

export const defaultContext = {};

export const NotificationContext = React.createContext(defaultContext);
